export const getStringValue = (value: unknown): string => {
  return typeof value === "number" ? value.toString() : String(value ?? "");
};
